import { useEffect } from "react";
import { useNavigate } from "react-router";

import { useRootStore } from "store";
import { logoutUser } from "common/MetaActions";

import "./OnetimeLogin.scss";

export default function OnetimeLogin() {
  const navigate = useNavigate();

  const urlParams = new URLSearchParams(window.location.search);
  const onetimeLoginGuid = urlParams.get("guid");

  const { onetimeLogin, invalid } = useRootStore(
    (state) => state.generateOnetimeLogin
  );

  const handleOnetimeLogin = () => {
    if (onetimeLoginGuid) {
      logoutUser();
      onetimeLogin(onetimeLoginGuid);
    } else {
      navigate("/login");
    }
  };

  useEffect(() => {
    handleOnetimeLogin();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const invalidDisplay = (
    <div>
      <h1>Kunde inte logga in</h1>
      <p>
        Engångslänken du angav är ogiltig.
        <br />
      </p>
      <p>
        <a href="/generate-onetime-login">Skapa en ny engångslänk.</a>
      </p>
    </div>
  );

  const defaultDisplay = <h1>Vänta medan du loggas in...</h1>;

  return (
    <div className="oneTimeLoginContainer">
      {invalid ? invalidDisplay : defaultDisplay}
    </div>
  );
}
